
const isMobileView = () => {

    return window.innerWidth < 500

}

export default isMobileView;
